import { render, staticRenderFns } from "./switchRoom.vue?vue&type=template&id=34b0be1b&"
import script from "./switchRoom.vue?vue&type=script&lang=js&"
export * from "./switchRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports